export default "__VITE_ASSET__BzQqpytJ__"